import 'video.js/dist/video';
import 'video.js/dist/video-js.css';

import {initSpoiler, initCheckSpoiler} from './common/spoiler';
import {initLanguages} from './common/languages';
import {initDropdownMenu} from './common/dropdown';
import {initTabs} from './common/tabs';
import {initRecaptchaForm, initInputCount} from './common/form';
import {initShowMore} from './common/show-more';
import {initWorkCardVideoPreviews} from './common/work-card-video-preview';
import {initImageGallery, initImage, initGallery} from './common/gallery';
import {initTooltipPopup} from './common/tooltip';
import initClipboardButtons from '../../common/js/clipboard-btn';
import { initModal } from './common/modal';
import initProfileWhereFindOut from './common/profile-where-find-out';
import initTableCheckedItems from './common/table-checked-items';
import initNotifications from './common/notification';
import initAvatarCabinet from './common/avatar-cabinet';
import initFrameWork from './common/iframe-work';
import initWbApplications from './wb-applications';
import initModals from './common/modals';
import {initContestWorkFormatsSettings} from './cabinet/contest-work-formats-settings';
import Tabs from "./common/new-tabs";
import DataTable from "datatables.net-dt";
import initRangeSlider from './common/range';
import {showDependsParams} from './cabinet/show-custom-fields-params';
import {initCompanySuggestions} from './cabinet/company-suggestions';
import {initAddressSuggestions} from './cabinet/address-suggestions';

document.addEventListener('DOMContentLoaded', () => {
  initModals();
  initAvatarCabinet();
  initSpoiler();
  initCheckSpoiler();
  initLanguages();
  initDropdownMenu();
  initTabs();
  initRecaptchaForm();
  initInputCount();
  initShowMore();
  initWorkCardVideoPreviews();
  initImageGallery();
  initImage();
  initGallery();
  initTooltipPopup();
  initClipboardButtons();
  initModal();
  initProfileWhereFindOut();
  initTableCheckedItems();
  initNotifications();
  initFrameWork();
  initWbApplications();
  initContestWorkFormatsSettings();
  initRangeSlider();
  showDependsParams();
  initCompanySuggestions();
  initAddressSuggestions();

  new Tabs();

  new DataTable(".options-table", {
    responsive: true,
    ordering: false,
    info: false,
    dom: '<"top"<"float-end"f>>rt<"bottom"<"float-start"l><"float-end"p>>',
    language: {
      lengthMenu: "_MENU_",
      zeroRecords: "Ничего не найдено",
      info: "Показано с _START_ по _END_ из _TOTAL_ записей",
      infoEmpty: "Показано 0 записей",
      infoFiltered: "(отфильтровано из _MAX_ общих записей)",
      search: "",
      searchPlaceholder: "Поиск...",
      paginate: {
        first: "«",
        last: "»",
        next: "→",
        previous: "←",
      },
    },
  });
});
